import React, { useEffect, useRef, useState, useCallback } from "react";
import Webcam from "react-webcam";
import ReactDom from "react-dom";
import {
  getAllCards,
  createContact,
  checkIsMobile,
  invokeOCR,
} from "../../constants";
import { ToastContainer, toast } from "react-toastify";
import { FaCamera } from "react-icons/fa";

const ModalCaptureContactData = ({
  setShowCapture,
  setFirstName,
  setLastName,
  setJobTitle,
  setCompany,
}) => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const webcamRef = useRef(null);
  const isMobile = checkIsMobile();
  const [imageSrc, setImageSrc] = useState(null);
  const [scanning, setScanning] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(null);

  useEffect(() => {
    if (imageSrc) {
      setScanning(true);
      invokeOCR(
        token,
        imageSrc,
        setFirstName,
        setLastName,
        setCompany,
        setJobTitle,
        null,
        null,
        setScanning,
        setShowCapture,
      );
    }
  }, [imageSrc]);

  const capture = useCallback(() => {
    // Returns a base64 encoded string
    setLoadingScreen(
      [
        "https://media1.tenor.com/m/HUQpvmDOmpwAAAAC/sad.gif",
        "https://media1.tenor.com/m/0AQkPI826b8AAAAd/i-will-scan-you-now-baymax.gif",
        "https://media1.tenor.com/m/6be0tZhr50QAAAAC/lazy-cat.gif",
        "https://media1.tenor.com/m/TXEFuo0j0DYAAAAC/we-are-waiting-estamos-esperando.gif",
        "https://media1.tenor.com/m/AABwxLmEslsAAAAd/two-hours-later-countdown.gif",
        "https://media1.tenor.com/m/sbCB5tCzPlYAAAAC/spongebob.gif",
        "https://media1.tenor.com/m/-OoplBxdX2QAAAAd/patiently-waiting-waiting.gif",
      ][Math.floor(Math.random() * 7)],
    );

    const imgSrc = webcamRef.current.getScreenshot();
    if (!imgSrc) return;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      // Define your orange square's dimensions and position (in pixels)
      // These should match the CSS you used to draw the square overlay
      const cropWidth = 320;
      const cropHeight = 320 / 1.75;
      const cropX = img.width / 2 - cropWidth / 2;
      const cropY = img.height / 2 - cropHeight / 2;

      canvas.width = cropWidth;
      canvas.height = cropHeight;

      // drawImage(source, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight)
      ctx.drawImage(
        img,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight,
      );

      const croppedBase64 = canvas.toDataURL("image/jpeg");
      setImageSrc(croppedBase64);
    };
    img.src = imgSrc;
  }, [webcamRef]);

  return ReactDom.createPortal(
    <div className="flex flex-col fixed h-[100vh] w-[100vw] bg-opacity-30 bg-gray-400 top-0 left-0 z-[999999] backdrop-blur-sm justify-center items-center">
      <div className="modal-box flex flex-col justify-between max-w-none w-full md:w-fit p-10 gap-4 h-full md:h-fit items-center justify-center">
        {scanning ? (
          <img src={loadingScreen} alt="Scanning card" />
        ) : (
          <div className="relative">
            <Webcam
              audio={false} // Disable audio
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={{
                facingMode: isMobile ? "environment" : "user",
              }}
            />
            <div
              className={`${isMobile ? "h-[50%] aspect-[0.5625]" : "w-[50%] aspect-[1.75]"} border rounded-lg border-primary absolute top-1/2 -translate-y-[50%] left-1/2 -translate-x-[50%]`}
            ></div>
            <div
              onClick={capture}
              className="flex flex-col items-center hover:bg-gray-200 cursor-pointer justify-center text-primary w-[10%] aspect-[1] bg-white rounded-full absolute bottom-5 left-1/2 -translate-x-[50%]"
            >
              <FaCamera />
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                setShowCapture(false);
              }}
              className="flex flex-col items-center font-bold hover:bg-red-200 cursor-pointer justify-center text-primary w-[5%] aspect-[1] bg-white rounded-full absolute bottom-8 right-1/3 -translate-x-[50%]"
            >
              X
            </div>
          </div>
        )}
      </div>
    </div>,
    document.getElementById("portal"),
  );
};

export default ModalCaptureContactData;
